export default "__VITE_ASSET__qOtiUZwE__"